import { Dispatch, SetStateAction, useState } from "react";
import { useAppSelector } from "@store/hooks";
import { selectCategories } from "@store/selectors";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { TOUR } from "@features/onboarding/tourTargets";

interface Props {
  setCategoryFilter: Dispatch<SetStateAction<string>>;
}

const FilterCategories = ({ setCategoryFilter }: Props) => {
  const categories = useAppSelector(selectCategories);
  const [labelCategory, setLabelCategory] = useState("");

  const handleSelectedCategory = (event: SelectChangeEvent) => {
    setCategoryFilter(event.target.value);
    setLabelCategory(event.target.value);
  };
  return (
    <FormControl data-tour={TOUR.categoryFilter} fullWidth sx={{ width: "100%" }}>
      <Select value={labelCategory} onChange={handleSelectedCategory}>
        <MenuItem value="None">None</MenuItem>
        {categories.map((category) => (
          <MenuItem key={category.label} value={category.label}>
            {category.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>Filter Categories</FormHelperText>
    </FormControl>
  );
};

export default FilterCategories;
